/**
 * Shared LaTeX cleanup for InlineMath and MathBlock's KaTeX render calls.
 *
 * The extraction service emits primes inconsistently: sometimes braced
 * (`f^{'''}`, which KaTeX accepts) and sometimes bare (`f^'`, which it
 * rejects with "Expected group after '^'" -- KaTeX requires `^`'s argument to
 * be a group or a single ordinary character, and a bare `'` is neither).
 * Bracing it is a no-op for the already-correct cases and a fix for the rest.
 */
const BARE_PRIME_SUPERSCRIPT = /\^(?!\{)('+)/g;

/**
 * TeX control words are a backslash followed by a run of letters, so a bare
 * letter argument right after `\frac` gets swallowed into the command name
 * instead of parsed as its first argument -- `\fracm2` tokenizes as the
 * unknown command `\fracm` followed by `2`, not `\frac{m}{2}`. A digit-first
 * argument (`\frac12`) has no such ambiguity: digits never extend a control
 * word, so KaTeX already reads it correctly and is left alone here.
 */
const BARE_LETTER_FRAC_ARG = /\\frac([a-zA-Z])/g;

export function normalizeLatex(latex: string): string {
  return latex
    .replace(BARE_PRIME_SUPERSCRIPT, '^{$1}')
    .replace(BARE_LETTER_FRAC_ARG, '\\frac{$1}');
}
